
const EnergyWeaponConfig = () => {
    const config = {
        maxTargets: 10,
        radius: 0.00808,
        powerScale: 6,
        duration: 15000,
        cost: 50,
    }
    return config;
}

export default EnergyWeaponConfig;